import * as React from 'react'
import {Chip} from '@mui/material'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined'
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined'
import {FREEZE_LEVEL, FREEZE_LEVEL_LABEL} from '../data/reference'
import {chipSentenceSx} from '../components/tone'

/**
 * The freeze-level chip: a per-level icon plus the LABEL, never the stored
 * value. `req.level` on every request is the STORED string ('SKU',
 * 'Sub-category' or 'Combo'); 'Combo' displays as 'Combination'
 * (data/reference.js's `FREEZE_LEVEL_LABEL`). This chip only ever reads
 * that map — it never compares anything against the label itself.
 *
 * `chipSentenceSx` takes a TONE NAME, not a raw colour (see
 * components/tone.js) — 'neutral' resolves to MUTED, the same grey every
 * other neutral chip in this module uses. The sentence variant, not the plain
 * one, because the theme's `capitalize` on `.MuiChip-label` splits on the
 * hyphen and would print the 'Sub-category' label as 'Sub-Category'.
 */
const LEVEL_ICON = {
  [FREEZE_LEVEL.SKU]: Inventory2OutlinedIcon,
  [FREEZE_LEVEL.SUBCAT]: LayersOutlinedIcon,
  [FREEZE_LEVEL.COMBO]: WidgetsOutlinedIcon,
}

export default function RqLevelChip({level}) {
  const Icon = LEVEL_ICON[level] || Inventory2OutlinedIcon
  const label = FREEZE_LEVEL_LABEL[level] || level

  return (
    <Chip
      size='small'
      icon={<Icon />}
      label={label}
      sx={{...chipSentenceSx('neutral'), '& .MuiChip-icon': {fontSize: 14, color: 'inherit', ml: '6px'}}}
    />
  )
}
